import * as R from 'ramda'
import {
  select,
  fork,
  put,
  all,
  call,
  take,
  takeLatest,
  takeEvery,
  cancelled,
} from 'redux-saga/effects'
import { connect } from 'react-redux'
import {
  compose,
  lifecycle,
} from 'recompose'

import { createNamedAction } from 'helpers/ActionUtil'

import injectSagas from 'helpers/injectSagas'

import {
  MODULE_NAME
} from './constants'

import {
  updateValidationValue
} from 'containers/Form/RiskValidation/actions'

import {
  showRiskSelector
} from 'containers/Form/RiskValidation/selectors'

import {
  getPath
} from 'containers/Form/util'

function withRiskSagas(pathName, elementId, actionNames) {
  const path = getPath(pathName, elementId)
  const updateValidationValueAction = createNamedAction(path, updateValidationValue)

  function* handleValueChange() {
    yield put(updateValidationValueAction())
  }

  function* watchValueChange() {
    while(true) {
      const action = yield take(actionNames)
      if (action.name === path)
        yield fork(handleValueChange)
    }
  }

  function* sagas() {
    yield all([
      fork(watchValueChange),
    ])
  }

  return injectSagas({ [`${MODULE_NAME}_${path}`]: sagas })
}

const withRisk = (pathName, elementId) => {
  const isRiskSelector = showRiskSelector(elementId)
  const path = getPath(pathName, elementId)
  const updateValidationValueAction = createNamedAction(path, updateValidationValue)

  const mapStateToProps = (state) => {
    return {
      isRisk: isRiskSelector(state),
    }
  }

  const mapDispatchToProps = dispatch => {
    return {
      registerElement: () => dispatch(updateValidationValueAction())
    }
  }

  const withConnect = connect(mapStateToProps, mapDispatchToProps)

  const withElementRegistration = lifecycle({
    componentDidMount() {
      this.props.registerElement()
    }
  })

  return compose(
    withConnect,
    withElementRegistration
  )
}

export {
  withRiskSagas,
  withRisk
}
